import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Table from '../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { getLegalManifestCargoDetail } from '../../../../actions/legal/LegalManifestCargo';
import { LEGAL_MANIFEST_CARGO_DETAIL_COLUMNS } from '../../../../config/columns';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';

const LegalManifestCargoDetail = ({
  dispatchGetLegalManifestCargoDetail,
  manifestId,
  sourceSystem,
  manifestCode,
  betterezManifestId
}) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchDetails = async () => {
      setLoading(true);
      const result = await dispatchGetLegalManifestCargoDetail({ flitId: manifestId, sourceSystem, manifestCode, betterezManifestId });
      setDetails(Array.isArray(result) ? result : []);
      setLoading(false);
    };

    fetchDetails();

  }, []);

  return (
    <>
      <h3>Detalle del Manifiesto de Carga</h3>
      <Table
        manual={false}
        columns={LEGAL_MANIFEST_CARGO_DETAIL_COLUMNS}
        data={details}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
        loading={loading}
      />
    </>
  );
};

LegalManifestCargoDetail.propTypes = {
  dispatchGetLegalManifestCargoDetail: PropTypes.func.isRequired,
  manifestId: PropTypes.number.isRequired,
  sourceSystem: PropTypes.string.isRequired,
  manifestCode: PropTypes.string,
  betterezManifestId: PropTypes.string,
};

LegalManifestCargoDetail.defaultProps = {
  manifestCode: null,
  betterezManifestId: null,
};

const mapDispatchToProps = {
  dispatchGetLegalManifestCargoDetail: getLegalManifestCargoDetail,
};

export default connect(null, mapDispatchToProps)(LegalManifestCargoDetail);
